import { render, staticRenderFns } from "./ResourcesFolderGrid.vue?vue&type=template&id=6cce7a0e&scoped=true&"
import script from "./ResourcesFolderGrid.vue?vue&type=script&lang=js&"
export * from "./ResourcesFolderGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesFolderGrid.vue?vue&type=style&index=0&id=6cce7a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce7a0e",
  null
  
)

export default component.exports